
//login user
export const LOAD_USER_REQUEST = "LOAD_USER_REQUEST";
export const LOAD_USER_SUCCESS = "LOAD_USER_SUCCESS";
export const LOAD_USER_FAIL = "LOAD_USER_FAIL";


//clear
export const CLEAR_USER_ERROR = "CLEAR_USER_ERROR";
